"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRenewalsSummary = exports.findRenewals = exports.getDisplayKeywordByAvgUsage = exports.getDisplayKeywordByAvgRating = exports.calculateNewAndCancelledTools = exports.getKeyInsightsDataFromReviews = void 0;
var end2end_1 = require("@hudled/end2end");
var date_fns_1 = require("date-fns");
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var processExpenditures_1 = require("./processExpenditures");
// in a hurry, pls remove and fix this file....
var ALL_KEY_INSIGHT_TYPES = ['rating', 'usage', 'rateAndUse', 'rateButUse', 'newApp', 'cancelled', 'ratingAndUsage',
    'dormant', 'unusedSubscription', 'spend', 'spendYtYMo', 'spendQtQ', 'spendQtQfromZero', 'spendMtM', 'spendProjected',
    'valueForMoney'];
var getKeyInsightsDataFromReviews = function (serviceStatsWithExtras, recommendations, keyInsightTypes) {
    if (keyInsightTypes === void 0) { keyInsightTypes = ALL_KEY_INSIGHT_TYPES; }
    var keyInsightsData = [];
    keyInsightTypes.forEach(function (keyInsightType) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (keyInsightType === 'rating') {
            keyInsightsData.push({ templateName: 'rating', avgRating: (serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgRating) || 0 });
        }
        if (keyInsightType === 'usage') {
            keyInsightsData.push({ templateName: 'usage', avgUsage: (serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgUsage) || 0 });
        }
        if (keyInsightType === 'rateAndUse') {
            keyInsightsData.push({
                templateName: 'rateAndUse', avgRating: (_a = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgRating) !== null && _a !== void 0 ? _a : 0, avgUsage: (_b = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgUsage) !== null && _b !== void 0 ? _b : 0,
            });
        }
        if (keyInsightType === 'rateButUse') {
            keyInsightsData.push({
                templateName: 'rateButUse', avgRating: (serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgRating) || 0, avgUsage: (serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.avgUsage) || 0,
            });
        }
        if (keyInsightType === 'newApp') {
            if ((serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.oldestTransactionDate) || ((_d = (_c = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.pricingPlans) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.activationDate)) {
                var activationDate = ((_f = (_e = serviceStatsWithExtras.pricingPlans) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.activationDate)
                    || serviceStatsWithExtras.oldestTransactionDate;
                if (activationDate && checkTwoDateDifferenceInDays(activationDate.toDate(), new Date()) <= 90) {
                    keyInsightsData.push({ templateName: 'newApp' });
                }
            }
        }
        if (keyInsightType === 'cancelled') {
            if ((serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.pricingPlans) && ((_g = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.pricingPlans[0]) === null || _g === void 0 ? void 0 : _g.cancellationDate)) {
                var cancellationDate = (_h = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.pricingPlans[0]) === null || _h === void 0 ? void 0 : _h.cancellationDate.toDate();
                if (checkTwoDateDifferenceInDays(cancellationDate, new Date()) >= 90) {
                    keyInsightsData.push({ templateName: 'cancelled' });
                }
            }
        }
        // if (keyInsightType === 'dormant') {
        //   if (hasRecommendation(RECOMMENDATIONS_TYPE.DORM, recommendations)) {
        //     const keyInsightData = { templateName: 'dormant', count: null };
        //     keyInsightData.count = getDormantUserCount(RECOMMENDATIONS_TYPE.DORM, recommendations)
        //       || countDormantUsers(serviceStatsWithExtras?.reviews);
        //     if (keyInsightData.count) {
        //       keyInsightsData.push(keyInsightData);
        //     }
        //   }
        // }
        // if (keyInsightType === 'unusedSubscription') {
        //   if (hasRecommendation(RECOMMENDATIONS_TYPE.USUB, recommendations)) {
        //     keyInsightsData.push({ templateName: 'unusedSubscription' });
        //   }
        // }
        // if (keyInsightType === 'spendIncidence') {
        //   if (serviceStatsWithExtras?.calculatedAnnualSpend && serviceStatsWithExtras?.calculatedAnnualSpendOfAllServices) {
        //     const keyInsightData = { templateName: 'spendIncidence', percentage: null };
        //     const currentServiceAnnualSpending = serviceStatsWithExtras?.calculatedAnnualSpend;
        //     const totalAnnualSpendingOfAllServices = serviceStatsWithExtras?.calculatedAnnualSpendOfAllServices;
        //
        //     keyInsightData.percentage = currentServiceAnnualSpending / totalAnnualSpendingOfAllServices;
        //     if (keyInsightData.percentage >= 0.01) {
        //       keyInsightsData.push(keyInsightData);
        //     }
        //   }
        // }
        if (keyInsightType === 'spendYtYMo') {
            var lastMonth = getMonthlyTotal((_k = (_j = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures) === null || _j === void 0 ? void 0 : _j['2020']) === null || _k === void 0 ? void 0 : _k['6']);
            var sameMonthLastYear = getMonthlyTotal((_m = (_l = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures) === null || _l === void 0 ? void 0 : _l['2019']) === null || _m === void 0 ? void 0 : _m['7']);
            if (lastMonth && sameMonthLastYear) {
                var keyInsightData = { templateName: 'spendYtYMo', percentage: 0, keyword: '' };
                keyInsightData.percentage = (lastMonth - sameMonthLastYear) / sameMonthLastYear;
                keyInsightData.keyword = keyInsightData.percentage > 0 ? 'up' : 'down';
                if (keyInsightData.percentage !== 0) {
                    keyInsightsData.push(keyInsightData);
                }
            }
        }
        if (keyInsightType === 'spendQtQ') {
            if ((_o = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures) === null || _o === void 0 ? void 0 : _o['2020']) {
                var currentYearExpenditure = (_p = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures) === null || _p === void 0 ? void 0 : _p['2020'];
                var spendingQ4 = getQuaterlyTotal(currentYearExpenditure, 'Q4');
                var spendingQ3 = getQuaterlyTotal(currentYearExpenditure, 'Q3');
                var keyInsightData = { templateName: 'spendQtQ', percentage: 0, keyword: '' };
                if (spendingQ4 && spendingQ3 && spendingQ4 !== spendingQ3) {
                    keyInsightData.percentage = (spendingQ4 - spendingQ3) / spendingQ3;
                    keyInsightData.keyword = spendingQ4 > spendingQ3 ? 'up' : 'down';
                    keyInsightsData.push(keyInsightData);
                }
            }
        }
        if (keyInsightType === 'spendQtQfromZero') {
            var currentYearExpenditure = (_q = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures) === null || _q === void 0 ? void 0 : _q['2020'];
            var spendingQ4 = getQuaterlyTotal(currentYearExpenditure, 'Q4');
            var spendingQ3 = getQuaterlyTotal(currentYearExpenditure, 'Q3');
            if (spendingQ3 === 0 && spendingQ4 !== 0) {
                keyInsightsData.push({ templateName: 'spendQtQfromZero', amount: Math.round(spendingQ4), keyword: 'up' });
            }
        }
        if (keyInsightType === 'spendMtM') {
            var exp = serviceStatsWithExtras === null || serviceStatsWithExtras === void 0 ? void 0 : serviceStatsWithExtras.expenditures;
            if (!exp)
                return;
            var mostRecentYear = Math.max.apply(Math, __spreadArray([], __read(Object.keys(exp).map(Number)), false));
            var monthsOrderedDesc = Object.keys(exp[mostRecentYear]).map(Number).sort(function (a, b) { return b - a; });
            var mostRecentMonth = monthsOrderedDesc[0];
            var secondMostRecentMonth = monthsOrderedDesc[1];
            var totalSpendOfTheMostRecentMonth = (0, processExpenditures_1.aggregateMonthlyTransactions)(exp[mostRecentYear][mostRecentMonth]);
            var totalSpendOfThe2dMostRecentMonth = (0, processExpenditures_1.aggregateMonthlyTransactions)(exp[mostRecentYear][secondMostRecentMonth]);
            if (totalSpendOfTheMostRecentMonth && totalSpendOfThe2dMostRecentMonth) {
                var percentage = (totalSpendOfTheMostRecentMonth - totalSpendOfThe2dMostRecentMonth) / totalSpendOfThe2dMostRecentMonth;
                if (percentage !== 0) {
                    keyInsightsData.push({
                        templateName: 'spendMtM',
                        percentage: percentage,
                        lastAvailableMonth: "".concat(monthNames[Number(mostRecentMonth) - 1], " ").concat(mostRecentYear),
                        secondLastAvailableMonth: "".concat(monthNames[Number(secondMostRecentMonth) - 1], " ").concat(mostRecentYear),
                        keyword: percentage > 0 ? 'up' : 'down',
                    });
                }
            }
        }
    });
    return keyInsightsData;
};
exports.getKeyInsightsDataFromReviews = getKeyInsightsDataFromReviews;
var calculateNewAndCancelledTools = function (serviceStatsWithService, lastAvailableMonth) {
    var newAppsLogo = [];
    var allNewApps = [];
    var allCancelledApps = [];
    var newAndCancelledTools = {
        templateName: 'newAndCancelled',
        isNewApp: false,
        isCancelled: false,
        newAppsCount: 0,
        cancelledAppsCount: 0,
        lastAvailableMonth: lastAvailableMonth,
        newAppsLogo: [],
        allNewApps: [],
        allCancelledApps: [],
    };
    var lastMonth = (0, date_fns_1.sub)(new Date(), { months: 1 });
    serviceStatsWithService.forEach(function (_a) {
        var pricingPlans = _a.pricingPlans, serviceId = _a.serviceId, service = _a.service, oldestTransactionDate = _a.oldestTransactionDate;
        if (!(pricingPlans === null || pricingPlans === void 0 ? void 0 : pricingPlans.length) && oldestTransactionDate) {
            if ((0, date_fns_1.isSameMonth)(lastMonth, oldestTransactionDate.toDate())) {
                newAndCancelledTools.isNewApp = true;
                newAndCancelledTools.newAppsCount += 1;
                newAppsLogo.push((service === null || service === void 0 ? void 0 : service.logoUrl) || '');
                var name_1 = service.name, logoUrl = service.logoUrl;
                allNewApps.push({ id: serviceId, name: name_1, logoUrl: logoUrl });
            }
        }
        else {
            pricingPlans === null || pricingPlans === void 0 ? void 0 : pricingPlans.forEach(function (pricingPlan) {
                var activationDate = pricingPlan.activationDate || oldestTransactionDate;
                if (activationDate) {
                    if ((0, date_fns_1.isSameMonth)(lastMonth, activationDate.toDate())) {
                        newAndCancelledTools.isNewApp = true;
                        newAndCancelledTools.newAppsCount += 1;
                        newAppsLogo.push((service === null || service === void 0 ? void 0 : service.logoUrl) || '');
                        var name_2 = service.name, logoUrl = service.logoUrl;
                        allNewApps.push({ id: serviceId, name: name_2, logoUrl: logoUrl });
                    }
                }
                else if (pricingPlan.cancellationDate
                    && pricingPlan.cancellationDate.toDate() >= (0, date_fns_1.startOfMonth)((0, date_fns_1.sub)(new Date(), { months: 1 }))) {
                    newAndCancelledTools.isCancelled = true;
                    newAndCancelledTools.cancelledAppsCount += 1;
                    var name_3 = service.name, logoUrl = service.logoUrl;
                    allCancelledApps.push({ id: serviceId, name: name_3, logoUrl: logoUrl });
                }
            });
        }
    });
    newAndCancelledTools.allNewApps = (0, uniqBy_1.default)(allNewApps, 'name');
    newAndCancelledTools.allCancelledApps = allCancelledApps;
    newAndCancelledTools.newAppsLogo = newAppsLogo;
    return newAndCancelledTools;
};
exports.calculateNewAndCancelledTools = calculateNewAndCancelledTools;
var getDisplayKeywordByAvgRating = function (avgRating) {
    switch (true) {
        case (avgRating >= 4.0):
            return 'loves';
        case (avgRating >= 3.5 && avgRating < 4.0):
            return 'moderately likes';
        case (avgRating >= 2.8 && avgRating < 3.5):
            return 'dislikes';
        case (avgRating < 2.8):
            return 'hates';
        default:
            return '';
    }
};
exports.getDisplayKeywordByAvgRating = getDisplayKeywordByAvgRating;
var getDisplayKeywordByAvgUsage = function (avgUsage) {
    switch (true) {
        case (avgUsage > 0.8):
            return 'always';
        case (avgUsage >= 0.6 && avgUsage < 0.8):
            return 'actively';
        case (avgUsage > 0.4 && avgUsage < 0.6):
            return 'often';
        case (avgUsage >= 0.25 && avgUsage <= 0.4):
            return 'occasionally';
        case (avgUsage >= 0.05 && avgUsage < 0.25):
            return 'rarely';
        case (avgUsage < 0.05):
            return 'never';
        default:
            return '';
    }
};
exports.getDisplayKeywordByAvgUsage = getDisplayKeywordByAvgUsage;
var checkTwoDateDifferenceInDays = function (dt1, dt2) { return (dt2.getTime() - dt1.getTime()) / (1000 * 3600 * 24); };
// const countDormantUsers = (reviews) => reviews
//   .reduce((count, review) => (review.accessType === 'Own' && review.usageLevel === 0) ? count + 1 : count, 0);
// const hasRecommendation = (keyword, recommendations) => recommendations?.some((recommendation) => recommendation?.type === keyword);
//
// const getDormantUserCount = (keyword, recommendations) => {
//   let dormantUsersCount = null;
//   recommendations.forEach((recommendation) => {
//     if (recommendation.type === keyword) {
//       dormantUsersCount = recommendation?.dormantUsersCount;
//     }
//   });
//   return dormantUsersCount;
// };
var getMonthlyTotal = function (monthInExpenditure) { return monthInExpenditure === null || monthInExpenditure === void 0 ? void 0 : monthInExpenditure.reduce(function (accTransaction, transaction) { return accTransaction + transaction.amount; }, 0); };
var getQuaterlyTotal = function (yearInExpenditure, Quarter) {
    // Definition:
    // Q1 = Jul-Sep
    // Q1 = Oct-Dec
    // Q3 = Jan-Mar
    // Q4 = Apr-Jun
    var MonthsInQuarter = [];
    if (Quarter === 'Q4') {
        MonthsInQuarter = ['4', '5', '6'];
    }
    else if (Quarter === 'Q3') {
        MonthsInQuarter = ['1', '2', '3'];
    }
    return MonthsInQuarter.reduce(function (total, month) {
        var _a;
        var monthlySpending = (yearInExpenditure === null || yearInExpenditure === void 0 ? void 0 : yearInExpenditure[month])
            ? (_a = yearInExpenditure[month]) === null || _a === void 0 ? void 0 : _a.reduce(function (tot, transaction) { return tot + (transaction.amount || 0); }, 0)
            : 0;
        return total + monthlySpending;
    }, 0);
};
var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October',
    'November', 'December'];
var findRenewals = function (serviceStatWithService, actualThisMonth, nextMonth, theFollowingMonth) { return serviceStatWithService
    .filter(function (serviceStat) { var _a; return serviceStat.expenditures && ((_a = serviceStat.pricingPlans) === null || _a === void 0 ? void 0 : _a.some(function (plan) { return plan.isYearly; })); })
    .map(function (_a) {
    var _b;
    var expenditures = _a.expenditures, service = _a.service, serviceId = _a.serviceId;
    if (!(service === null || service === void 0 ? void 0 : service.name)) {
        return null;
    }
    var thisMonth = actualThisMonth[1];
    var lastY = actualThisMonth[0];
    var thisYear = actualThisMonth[0] + 1;
    var lastYExpenditures = expenditures && expenditures[lastY] && [actualThisMonth, nextMonth, theFollowingMonth]
        .map(function (_a) {
        var _b;
        var _c = __read(_a, 2), year = _c[0], month = _c[1];
        return expenditures && ((_b = expenditures[year]) === null || _b === void 0 ? void 0 : _b[month]);
    }).filter(function (el) { return el != null; });
    if (!(lastYExpenditures === null || lastYExpenditures === void 0 ? void 0 : lastYExpenditures.length)) {
        return null;
    }
    if (expenditures && ((_b = expenditures[thisYear]) === null || _b === void 0 ? void 0 : _b[thisMonth])) { // already paid this month?
        lastYExpenditures.shift();
    }
    if (lastYExpenditures === null || lastYExpenditures === void 0 ? void 0 : lastYExpenditures.length) {
        var total_1 = 0;
        var monthsIndex_1 = [1, 2];
        lastYExpenditures === null || lastYExpenditures === void 0 ? void 0 : lastYExpenditures.forEach(function (items) {
            items.forEach(function (item) {
                monthsIndex_1.push(item.date.toDate().getMonth());
                total_1 += item.amount;
            });
        });
        var dueIn = Array.from(new Set(monthsIndex_1)).sort().map(function (month) { return monthNames[month]; });
        return {
            amount: total_1, logoUrl: service.logoUrl, id: serviceId, name: service.name,
            dueIn: dueIn,
        };
    }
    // const expenditureExtraInActivationMonth = expenditures[lastY][thisMonth]
    //   .filter((expenditureActivationMonth) => !expenditures[lastY][thisMonth - 1]
    //     ?.map((expenditureMonthBeforeActivation) => expenditureMonthBeforeActivation.amount)
    //     .includes(expenditureActivationMonth.amount));
    // if (expenditureExtraInActivationMonth.length === 1) {
    //   return { amount: expenditureExtraInActivationMonth[0].amount, logo: service.logo };
    // } // TODO: handle if 2?
    return null;
})
    .filter(end2end_1.notFalsy); };
exports.findRenewals = findRenewals;
var getMonthDatePair = function (date) { return [date.getFullYear(), date.getMonth() + 1]; };
var getRenewalsSummary = function (serviceStatWithService) {
    var nextMonth = getMonthDatePair((0, date_fns_1.add)(new Date(), { months: 1 }));
    var theFollowingMonth = getMonthDatePair((0, date_fns_1.add)(new Date(), { months: 2 }));
    var actualThisMonth = getMonthDatePair((0, date_fns_1.add)(new Date(), { years: 1 }));
    var renewals = (0, exports.findRenewals)(serviceStatWithService, actualThisMonth, nextMonth, theFollowingMonth);
    return {
        renewalSum: (0, sumBy_1.default)(renewals, 'amount'),
        templateName: 'renewalsAnnual',
        months: [monthNames[nextMonth[1] - 2], monthNames[nextMonth[1] - 1], monthNames[nextMonth[1]]],
        allRenewals: renewals,
    };
};
exports.getRenewalsSummary = getRenewalsSummary;
